import { render, staticRenderFns } from "./overview.vue?vue&type=template&id=b98059b2&scoped=true"
import script from "./overview.vue?vue&type=script&lang=js"
export * from "./overview.vue?vue&type=script&lang=js"
import style0 from "./overview.vue?vue&type=style&index=0&id=b98059b2&prod&scoped=true&lang=scss"
import style1 from "./overview.vue?vue&type=style&index=1&id=b98059b2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b98059b2",
  null
  
)

export default component.exports